<template>
  <div>
    <div class="outBig outBiga">
      <div class="outdiv">
        <el-form
          :model="userForm"
          :rules="rules"
          ref="userForm"
          size="mini"
          label-width="150px"
        >
          <el-form-item :label="$t('common.account')" prop="account">
            <span :class="userForm.account ? '' : 'nullSpan'">{{
              IsNull(userForm.account)
            }}</span>
          </el-form-item>
          <el-form-item :label="$t('common.role')" prop="role">
            <!-- <span>{{ userForm.role }}</span> -->
            <span v-if="$i18n.locale == 'en' && userForm.roleEn">{{
              userForm.roleEn
            }}</span>
            <span v-else>{{ userForm.role }}</span>
          </el-form-item>
          <el-form-item :label="$t('common.name')" prop="name">
            <el-input
              v-if="editMode"
              v-model="userForm.name"
              :placeholder="$t('common.pleaseInput')"
            ></el-input>
            <span v-if="!editMode" :class="userForm.name ? '' : 'nullSpan'">{{
              IsNull(userForm.name)
            }}</span>
          </el-form-item>
          <el-form-item :label="$t('common.sex')" prop="sex">
            <div v-if="editMode">
              <el-radio v-model="userForm.sex" label="男">{{
                $t("common.Male")
              }}</el-radio>
              <el-radio v-model="userForm.sex" label="女">{{
                $t("common.Female")
              }}</el-radio>
            </div>
            <span v-if="!editMode" :class="userForm.sex ? '' : 'nullSpan'">{{
              IsNull(userForm.sex)
            }}</span>
          </el-form-item>
          <el-form-item :label="$t('common.jigou')" prop="org">
            <el-input
              v-if="editMode"
              type="textarea"
              v-model="userForm.org"
              maxlength="1000"
              show-word-limit
              :placeholder="$t('common.pleaseInput')"
            ></el-input>
            <span v-if="!editMode" :class="userForm.org ? '' : 'nullSpan'">{{
              IsNull(userForm.org)
            }}</span>
          </el-form-item>
          <el-form-item :label="$t('common.bindingEmail')" prop="email">
            <span :class="userForm.email ? '' : 'nullSpan'">{{
              IsNull(userForm.email)
            }}</span>
          </el-form-item>
          <el-form-item :label="$t('common.bindingPhone')" prop="phoneNumber">
            <span :class="userForm.phoneNumber ? '' : 'nullSpan'">{{
              IsNull(userForm.phoneNumber)
            }}</span>
          </el-form-item>
          <el-form-item :label="$t('common.otherEmail')" prop="reserveEmail">
            <el-input
              v-if="editMode"
              v-model="userForm.reserveEmail"
              :placeholder="$t('common.pleaseInput')"
            ></el-input>
            <span
              v-if="!editMode"
              :class="userForm.reserveEmail ? '' : 'nullSpan'"
              >{{ IsNull(userForm.reserveEmail) }}</span
            >
          </el-form-item>
          <el-form-item
            :label="$t('common.otherPhone')"
            prop="reservePhoneNumber"
          >
            <el-input
              v-if="editMode"
              v-model="userForm.reservePhoneNumber"
              :placeholder="$t('common.pleaseInput')"
            ></el-input>
            <span
              v-if="!editMode"
              :class="userForm.reservePhoneNumber ? '' : 'nullSpan'"
              >{{ IsNull(userForm.reservePhoneNumber) }}</span
            >
          </el-form-item>

          <!--      评审员无该项-->

          <el-form-item
            v-if="authorityObj.isShow('#5#64#66')"
            label="是否愿意担任本次会议的评审员"
            prop="isWillReview"
          >
            <div v-if="editMode">
              <el-radio v-model="userForm.isWillReview" :label="1">{{
                $t("common.Yes")
              }}</el-radio>
              <el-radio v-model="userForm.isWillReview" :label="0">{{
                $t("common.No")
              }}</el-radio>
            </div>
            <span v-if="!editMode">{{
              userForm.isWillReview == "1" ? $t("common.Yes") : $t("common.No")
            }}</span>
          </el-form-item>
          <el-form-item :label="$t('common.research')" prop="researchField">
            <el-input
              v-if="editMode"
              type="textarea"
              v-model="userForm.researchField"
              :placeholder="$t('common.pleaseInput')"
            ></el-input>
            <span
              v-if="!editMode"
              :class="userForm.researchField ? '' : 'nullSpan'"
              >{{ IsNull(userForm.researchField) }}</span
            >
          </el-form-item>
          <el-form-item :label="$t('common.remark')" prop="remarks">
            <el-input
              v-if="editMode"
              type="textarea"
              v-model="userForm.remarks"
              :placeholder="$t('common.pleaseInput')"
            ></el-input>
            <span
              v-if="!editMode"
              :class="userForm.remarks ? '' : 'nullSpan'"
              >{{ IsNull(userForm.remarks) }}</span
            >
          </el-form-item>
          <el-form-item>
            <el-button
              v-if="!editMode"
              type="primary"
              @click="editMode = true"
              >{{ $t("common.edit") }}</el-button
            >
            <el-button
              v-if="editMode"
              type="primary"
              @click="submitForm('userForm')"
              >{{ $t("common.confirmEdit") }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="userCenterImgOut">
        <el-upload
          v-if="editMode"
          class="avatar-uploader"
          :action="uploadUrl"
          :show-file-list="false"
          :on-success="uploadSuccess"
          :before-upload="beforeUpload"
        >
          <el-image
            v-if="userForm.icon"
            :src="userForm.icon"
            class="avatar"
            fit="cover"
          />
          <img v-else :src="$oss.userIcon" />
          <span class="upload-tip">{{ $t("common.changeUserIcon") }}</span>
        </el-upload>
        <div v-if="!editMode">
          <el-image
            v-if="userForm.icon"
            :src="userForm.icon"
            class="avatar"
            fit="cover"
          />
          <img v-else :src="$oss.userIcon" />
        </div>
      </div>
    </div>
    <organ-add-component
      ref="organ-add-component"
      @choseOrgan="choseOrgan"
    ></organ-add-component>
  </div>
</template>
<script>
import organAddComponent from "@/components/paper/createUser/organAddComponent";
export default {
  props: ["paramEditMode"],
  data() {
    return {
      editMode: false,
      userForm: {
        account: "",
        role: "",
        name: "",
        sex: "",
        org: "",
        email: "",
        phone: "",
        reserveEmail: "",
        reservePhoneNumber: "",
        isWillReview: "1",
        researchField: "",
        remarks: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t("msg.enterName"),
            trigger: "blur",
          },
          {
            min: 2,
            max: 300,
            message: this.$t("msg.enterLength"),
            trigger: "blur",
          },
        ],
        org: [
          { required: true, message: this.$t("msg.enterIns"), trigger: "blur" },
        ],
        sex: [
          { required: true, message: this.$t("msg.choseSex"), trigger: "blur" },
        ],
      },

      // 头像相关
      uploadUrl:
        "http://47.104.20.126:20201/financial-search/api" + "/file/upload",
    };
  },
  components: {
    organAddComponent,
  },
  methods: {
    // clickOrgan(){
    //   this.$refs['organ-add-component'].handleOpen()
    // },
    choseOrgan(item) {
      this.userForm.orgCode = item.organCode;
      this.userForm.org = item.organName;
    },
    getUserDetail() {
      const data = this.userId
        ? {
            userId: this.userId,
          }
        : {};
      this.$api.getCrUserInfo(data, "get").then((res) => {
        console.log("res", res);
        if (res.code == 200) {
          this.userForm = res.data;
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = this.userForm;
          data.userId = this.userId;
          this.$api.editUserInfo(data).then((res) => {
            console.log("res", res);
            if (res.code == 200) {
              this.$message.success("用户信息编辑成功");
              this.editMode = false;
            }
          });
        }
      });
    },
    //头像相关
    // 上传图片成功
    uploadSuccess(res, file) {
      if (res.datas && res.datas.url) {
        const data = {
          icon: res.datas.url,
        };
        this.userForm.icon = res.datas.url;

        // this.$api.edit(data).then(resData=>{
        //   if(resData.result==1){
        //     // console.log('logoRes',resData)
        //     this.userForm.icon = res.datas.url
        //     localStorage.setItem("icon", res.datas.url);
        //   }
        //   else{
        //     this.$message({
        //       message:'操作失败，请稍后重试',
        //       type:'error'
        //     })
        //   }
        // })
      }
    },
    // 上传图片前文件校验
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式或 PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },
  created() {
    this.userId = this.$route.query.userId;
    this.editMode = this.paramEditMode;
    this.getUserDetail();
  },
};
</script>

<style scoped lang="scss">
.outBig {
  display: flex;
  justify-content: left;
  .outdiv {
    width: 800px;
  }
  .userCenterImgOut {
    .upload-tip {
      display: block;
      margin-top: 10px;
      font-size: 14px;
    }
  }
}
</style>
<style>
.userCenterImgOut img {
  width: 160px;
  height: 160px;
  border-radius: 100px;
}
</style>
